import type { DateRange } from '../../../../../shared/components/DurationSelector/types';
import type { GranularityMode } from '../../../../../shared/hooks/usePersistedGranularity';
import { calculateGranularity } from './calculateGranularity';

export const resolveGranularity = (
  mode: GranularityMode,
  dateRange: DateRange,
): 'hourly' | 'daily' | 'weekly' | 'monthly' => (mode === 'auto' ? calculateGranularity(dateRange) : mode);
